import Program from '../components/Program/components/Program';
import React, { useContext } from 'react';

import Layout, { MyLocationEnum } from '../components/Layout'
import DynamicContext from '../context'
import SEO, { MetaOG } from "../components/Seo"
import { useStaticQuery, graphql } from 'gatsby';

export default ({ location }) => {
  const { liveSpeaker, speakerLinks } = useContext(DynamicContext)

  const data = useStaticQuery(
    graphql`
      query {
        allSpeaker (sort: {fields: time, order: ASC}) {
          edges {
            node {
              id
              companyName
              speakerName
              slug
              title
              date
              time
              timeEnd
              image {
                childImageSharp {
                  fluid(maxWidth: 400, quality:100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
        }
        Background: file(relativePath: { eq: "stjornarradsBackground.jpg" }) {
          childImageSharp {
            fluid(quality: 55, maxWidth: 1800) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )
  
  const seo_og: MetaOG = {
    title: "Agenda",
    description: "Agenda for symposium - What will the future look like beyond COVID-19?",
  }

  return (
    <Layout location={location} myLocation={MyLocationEnum.Dagskra}>
      <SEO
        title="Agenda"
        description="Agenda for symposium - What will the future look like beyond COVID-19?"
        og={seo_og}
      />
      <Program 
        liveSpeaker={liveSpeaker}
        speakerLinks={speakerLinks}
        data={data.allSpeaker.edges}
        backgroundImage={data.Background}
        title="Agenda"
        liveUrl="/live"
        hideTimeline={false}
        smallerLogo={false}
      />
    </Layout>
  )
}
